import { render } from "./index.vue?vue&type=template&id=1477c51e&ts=true"
import script from "./view-model/index.ts?vue&type=script&lang=ts"
export * from "./view-model/index.ts?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=1477c51e&lang=less"

import exportComponent from "D:\\code\\customer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common-modal/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1477c51e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1477c51e', __exports__)) {
    console.log('reload')
    api.reload('1477c51e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1477c51e&ts=true", () => {
    console.log('re-render')
    api.rerender('1477c51e', render)
  })

}


export default __exports__